module.exports = "<div class=\"page-container\">\n    <div class=\"map-container\">\n     \n    </div>\n    <div class=\"post-container\">\n    </div>\n</div>"